import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { PermissionGroup } from "../Model/PermissionGroup";

export async function createPermissionGroup(data) {
	let response = await getAPIResponse("/v1/permission-group", data, "POST");
	if (response === null) {
		return null;
	}
	let permissionGroup = PermissionGroup.createFromResponseData(response);
	return permissionGroup;
}